import { action, extendObservable } from 'mobx';
import jwtDecode from 'jwt-decode';
import FetchService from '../../../core/services/FetchService';

class WarningContractBlockService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
      overdueBills: 0,
    });
  }

  getOverdueBills = () => {
    return this.fetch.fetch({
      url: '/bills',
      query: {
        query: {
          status: 'SENT_TO_CLIENT',
        },
        page: 1,
        size: 1,
      },
    });
  };

  getContract = (contractId) => {
    return this.fetch.fetch({
      url: `/contracts/${contractId}`,
    });
  };

  load = action(async () => {
    const user = jwtDecode(localStorage.accessToken);
    if (user.contract) {
      const data = await this.getOverdueBills();
      const contract = await this.getContract(user.contract);
      if (data && data.total) {
        this.overdueBills = data.total;
        this.daysUntilBlock = contract.daysUntilBlock;
        if (
          this.daysUntilBlock === 16 ||
          this.daysUntilBlock === 12 ||
          this.daysUntilBlock === 9 ||
          this.daysUntilBlock <= 4
        ) {
          this.isOpen = true;
        }
      }
    }
  });

  close = action(() => {
    this.isOpen = false;
  });
}

export default WarningContractBlockService;
